module.exports = __webpack_public_path__ + "img/iconTankTruck.34e0da97.svg";